import { NgModule } from '@angular/core';

import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './core/auth-guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'apteka',
    redirectTo: '/login',
    pathMatch: 'full',
  }, // specjalny route dla IE11
  {
    path: 'login',
    loadChildren: './login/login.module#LoginModule',
  },
  {
    path: 'map',
    loadChildren: './map/map.module#MapModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: './reports/reports.module#ReportsModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'devices-reports',
    loadChildren:
      './devices-reports/devices-reports.module#DevicesReportsModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'archive',
    loadChildren: './archive/archive.module#ArchiveModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'services',
    loadChildren: './services/services.module#ServicesModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'vehicles',
    loadChildren: './vehicles/vehicles.module#VehiclesModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'instruction',
    loadChildren: './instruction/instruction.module#InstructionModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'admin',
    outlet: 'adminContent',
    loadChildren: './admin-panel/admin-panel.module#AdminPanelModule',
    canLoad: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
